import { config } from '../../../../../config';
import { tokensPersistenceSelector } from '../../../../../services/selectors';
import { TOKENS_KEY } from "../config";
import { appSelect } from '../../../../../services/utils/reduxSaga';
export const storageDriver = persistence => config.mapStorageDriverToTokensPersistence[persistence];
export function* clearTokens(forcedPersistence) {
  const persistence = yield* appSelect(tokensPersistenceSelector);
  yield storageDriver(forcedPersistence || persistence).remove(TOKENS_KEY);
}
export function* storeTokens(tokens, forcedPersistence) {
  const persistence = yield* appSelect(tokensPersistenceSelector);
  yield storageDriver(forcedPersistence || persistence).set(TOKENS_KEY, tokens);
}
export function* retrieveTokens(forcedPersistence) {
  const persistence = yield* appSelect(tokensPersistenceSelector);
  return yield storageDriver(forcedPersistence || persistence).get(TOKENS_KEY);
}